import Image from 'next/future/image';
import SuperheroIcon from '@/public/images/buyback/reebel-superhero.png';
import OperaHouseIcon from '@/public/images/buyback/sydney-opera-house_2.svg';
import SupportIcon from '@/public/images/buyback/customer-support.png';
import ShieldIcon from '@/public/images/buyback/shield_5.png';
import LibertyIcon from '@/public/icons/buyback/liberty.svg';
import MerlionIcon from '@/public/images/buyback/merlion.png';
import SgPoliceIcon from '@/public/images/buyback/sg_police.png';
import settings from '@/settings';

const buyBackTrustData = [
  {
    img: OperaHouseIcon,
    title: `Based in ${settings.country}`,
    description: `We are on a mission to make 2nd hand the new cool in ${settings.country}!`,
  },
  {
    img: ShieldIcon,
    title: `Secure & Trustworthy`,
    description: `We partner with ${settings.country}'s most trusted buyback companies.`,
  },
  {
    img: SupportIcon,
    title: `100% Transparent`,
    description: `Our caring customer service will answer all your questions.`,
  },
  {
    img: SuperheroIcon,
    title: `500,000+ Climate Reebels`,
    description: `More than 500,000 happy customers are saving the planet with us.`,
  },
];

// modify to SG content
if (settings.store === 'quista') {
  buyBackTrustData[0].img = MerlionIcon;
  buyBackTrustData[0].title = 'Made in Singapore';
  buyBackTrustData[0].description =
    'We are on a mission to make 2nd hand the new cool in Singapore!';
  buyBackTrustData[1].img = SgPoliceIcon;
  buyBackTrustData[1].title = 'Registered & Trustworthy';
  buyBackTrustData[1].description =
    'Reebelo is a registered 2nd hand goods dealer with the SPF.';
} else if (settings.store === 'reebelo-us') {
  buyBackTrustData[0].img = LibertyIcon;
  buyBackTrustData[0].title = 'Made in the United States';
  buyBackTrustData[0].description =
    'We are on a mission to make 2nd hand the new cool in the United States!';
  buyBackTrustData[1].description = `We partner with the United States' most trusted buyback companies.`;
}

const buybackTitle =
  settings.store === 'reebelo-us'
    ? `The ${settings.country}' leading brands for sustainable tech. Combined in one platform.`
    : `${settings.country}'s leading brands for sustainable tech. Combined in one platform.`;

export default function TrustedFeatured() {
  return (
    <div className="flex flex-wrap rounded bg-blue-500">
      <div className="p-4 sm:w-2/5 sm:p-8 sm:px-6 lg:p-10">
        <h2 className="pb-4 text-xl font-bold text-white sm:pb-0 sm:text-2xl   ">
          {buybackTitle}
        </h2>
        <a
          href="https://www.trustpilot.com/review/reebelo.com"
          target="_blank"
          className="my-2 block text-sm text-white xxs:my-3 xs:mt-5 sm:mb-0"
        >
          Excellent 4.7 out of 5
        </a>
      </div>
      <div className="bg-white p-7 px-0 pb-5 sm:w-3/5 sm:py-8 sm:px-10">
        <div className="-mb-2 flex flex-wrap text-center sm:-mb-4">
          {(buyBackTrustData || []).map((item, index) => (
            <div
              key={index}
              className="mb-5 flex w-full px-4 sm:mb-4 sm:block sm:w-1/2"
            >
              <div className="w-9 sm:w-full">
                <Image
                  height={40}
                  width={40}
                  className="mx-auto w-10 object-center"
                  src={item?.img}
                  alt={item.title}
                />
              </div>
              <div className="w-full grow pl-4 text-left sm:pl-0 sm:text-center">
                <h2 className="my-0 text-[15px] font-semibold text-blue-500 sm:mt-2 sm:mb-1 sm:text-sm">
                  {item?.title}
                </h2>
                <p className="text-sm text-gray-700">{item?.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
